import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { from, Observable, ReplaySubject } from 'rxjs';
import { switchMap, tap } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import { UserData } from '../auth/userData';

@Injectable({
    providedIn: 'root',
})
export class PermissionEnforcer {
    public permissions: any[];
    private Role: string;

    constructor(private http: HttpClient, private userData: UserData) {
        this.permissions = [];
        this.onPermissionsChange.next(this.permissions);
    }

    onPermissionsChange = new ReplaySubject(1);

    // Fetch the permissions from the backend and store them
    loadPermissions(): Observable<any[]> {
        try {
            if (this.permissions.length !== 0) {
                return;
            }
            return from(this.userData.getRole()).pipe(
                switchMap((userRole) => {
                    this.Role = userRole;
                    // Passing the role as a query parameter
                    return this.http.get<any[]>(`${environment.apiBaseUrl}/api/v2/permissions`, {
                        params: { role: userRole },
                    });
                }),
                tap((permissions) => {
                    this.permissions = permissions;
                    this.onPermissionsChange.next(this.permissions);
                }),
            );
        } catch (error) {
            console.log('error occured');
        }
    }

    // Check if the user has permission using Casbin
    hasPermission(obj: string, act: string): boolean {
        // console.log(this.permissions);
        return this.permissions.some(
            (p) => p.role === this.Role && p.obj === obj && p.act === act && p.eft !== 'deny',
            // (p.eft == 'allow' || p.eft == undefined),
        );
    }
}
